const apiEnv = (prefix = 'ipa') => {
  return `https://${prefix}.fluxio.cloud/`
}
export default apiEnv
